import { Component, OnInit } from '@angular/core';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-support-documents-loan',
  templateUrl: './support-documents-loan.component.html',
  styleUrls: ['./support-documents-loan.component.scss'],
})
export class SupportDocumentsLoanComponent implements OnInit {

  documents: any;
  selectDocument: any;

  constructor(
    private headerService: HeaderService,
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
  ) {
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    this.selectDocument = this.abreCuentasService.getRequestLoanSelected().elementId + this.abreCuentasService.getOccupationSelected().id;
    this.listDocuments();
  }

  listDocuments() {
    switch (this.selectDocument) {
      case '011':
        this.documents = this.copyService.copies.support_documents_loan.uno;
        break;
      case '021':
        this.documents = this.copyService.copies.support_documents_loan.dos;
        break;
      case '015':
        this.documents = this.copyService.copies.support_documents_loan.tres;
        break;
      case '025':
        this.documents = this.copyService.copies.support_documents_loan.cuatro;
        break;
      default:
        this.documents = this.copyService.copies.support_documents_loan.uno;
        break;
    }
  }

  next() {
    this.navigationService.nextStep('200');
  }

}
